import React, { lazy, Suspense } from "react";

import Home from "./Default";
import { useUserOrganization } from "@/utils/partnerData";
import LoadingScreen from "@/components/LoadingScreen";
import ECRFHomepage from "./ECRF";

const CobbHomepage = lazy(() => import("./Cobb"));
const BDOHomepage = lazy(() => import("./BDO"));
const NavTrialsHomepage = lazy(() => import("./NavTrials"));

function Homepage() {
    const { userOrganization: org } = useUserOrganization();

    return (
        <Suspense fallback={<LoadingScreen />}>
            {(() => {
                switch (org.key) {
                    case "cobb":
                        return <CobbHomepage />;
                    case "bdo":
                        return <BDOHomepage />;
                    case "ecrf":
                        return <ECRFHomepage />;
                    case "navtrials":
                        return <NavTrialsHomepage />;
                    default:
                        return <Home />;
                }
            })()}
        </Suspense>
    );
}

export default Homepage;
